import { render, staticRenderFns } from "./TaskCancel.vue?vue&type=template&id=2c66221e"
import script from "./TaskCancel.vue?vue&type=script&lang=js"
export * from "./TaskCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports